<template>
    <div>
        <!-- 申请预付款抵扣界面 -->
        <el-dialog v-dialog-drag :visible.sync="showDialog" width="950px" :destroy-on-close="true" :before-close="cancel"
            title="申请预付款抵扣" class="change-detail-dialog">
            <div class="el-dialog-div">
                <!-- 合同基础信息 -->
                <div class="section-card">
                    <div class="section-header-bar">
                        <span class="section-title"><i class="el-icon-document"></i> 合同基础信息</span>
                        <el-button size="mini" type="text"
                            :icon="sectionOpen.contractInfo ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
                            @click="toggleSection('contractInfo')">{{ sectionOpen.contractInfo ? '收起' : '展开' }}</el-button>
                    </div>
                    <div v-show="sectionOpen.contractInfo" class="section-body">
                        <div class="detail-grid">
                            <div class="detail-item">
                                <span class="detail-label">合同编号</span>
                                <span class="detail-value contract-number-text">{{ contractInfo.contractNumber || '-'
                                    }}</span>
                            </div>
                            <div class="detail-item">
                                <span class="detail-label">执行合同编号</span>
                                <span class="detail-value">{{ contractInfo.executeContractNumber || 'NA' }}</span>
                            </div>
                            <div class="detail-item">
                                <span class="detail-label">合同名称</span>
                                <span class="detail-value">{{ contractInfo.contractName || '-' }}</span>
                            </div>
                            <div class="detail-item">
                                <span class="detail-label">合同类型</span>
                                <span class="detail-value">{{ contractInfo.projectType || '-' }}</span>
                            </div>
                            <div class="detail-item">
                                <span class="detail-label">合同分类</span>
                                <span class="detail-value">
                                    <el-tag size="mini" :type="getContractColor(contractInfo.contractType, 'tagType')"
                                        :style="{
                                            color: getContractColor(contractInfo.contractType, 'color'),
                                            'background-color': getContractColor(contractInfo.contractType, 'backgroundColor')
                                        }">
                                        {{ getContractColor(contractInfo.contractType, 'name') }}
                                    </el-tag>
                                </span>
                            </div>
                            <div class="detail-item">
                                <span class="detail-label">销售</span>
                                <span class="detail-value">{{ contractInfo.sales ? contractInfo.sales.name : '-' }}</span>
                            </div>
                            <div class="detail-item">
                                <span class="detail-label">委托方（甲方）</span>
                                <span class="detail-value contact-text">{{
                                    contractInfo.customerContacts ? contractInfo.customerContacts.contactName : '-'
                                    }}</span>
                            </div>
                            <div class="detail-item">
                                <span class="detail-label">受托方（乙方）</span>
                                <span class="detail-value">{{ contractInfo.baseCompany ?
                                    contractInfo.baseCompany.companyName : '-' }}</span>
                            </div>
                            <div class="detail-item full-width">
                                <span class="detail-label">签订地点</span>
                                <span class="detail-value">{{ contractInfo.signingPlace || '-' }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 抵扣信息 -->
                <div class="section-card">
                    <div class="section-header-bar">
                        <span class="section-title"><i class="el-icon-coin"></i> 抵扣信息</span>
                        <el-button size="mini" type="text"
                            :icon="sectionOpen.offsetInfo ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
                            @click="toggleSection('offsetInfo')">{{ sectionOpen.offsetInfo ? '收起' : '展开' }}</el-button>
                    </div>
                    <div v-show="sectionOpen.offsetInfo" class="section-body">
                        <div class="detail-grid">
                            <div class="detail-item">
                                <span class="detail-label">合同金额</span>
                                <span class="detail-value amount-text">{{ formatAmount(contractInfo.contractAmount)
                                    }}</span>
                            </div>
                            <div class="detail-item">
                                <span class="detail-label">已开票金额</span>
                                <span class="detail-value amount-text">{{
                                    formatAmount(contractInfo.actualInvoicedAmount) }}</span>
                            </div>
                            <div class="detail-item">
                                <span class="detail-label">申请抵扣金额</span>
                                <span class="detail-value amount-text">{{ formatAmount(form.offsetAmount) }}</span>
                            </div>
                            <div class="detail-item">
                                <span class="detail-label">剩余预付款</span>
                                <span class="detail-value amount-text" :class="{ 'insufficient-text': isInsufficient }">{{
                                    formatAmount(remainingAmount) }}</span>
                            </div>
                        </div>
                        <el-form :model="form" label-width="100px" ref="form" class="offset-form">
                            <el-form-item label="申请备注" prop="remark">
                                <el-input type="textarea" v-model="form.remark" placeholder="请输入申请备注（选填）"
                                    :rows="3" maxlength="300" show-word-limit></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>

                <div class="dialog-footer">
                    <el-button @click="cancel">取 消</el-button>
                    <el-button type="primary" :loading="loading" @click="handleSubmit">提交申请</el-button>
                </div>
            </div>
            <loading :loading="loading" load-text="提交中"></loading>
        </el-dialog>
    </div>
</template>

<script>
import { applyPrepaymentsDeduction } from "@/api/dilivery/sales/contract";
import { getUserAmountById } from "@/api/dilivery/customer/user";
import { getContractColor } from "@/color";
import Loading from "@/components/loading/Loading.vue";
import detailCommonMixin from "@/mixins/detailCommonMixin";

export default {
    name: "AddOffSet",
    mixins: [detailCommonMixin],
    components: { Loading },
    props: ['showDialog', 'selectDetail'],
    data() {
        return {
            loading: false,
            remainingAmount: null,//该用户剩余预付款
            sectionOpen: { contractInfo: true, offsetInfo: true },
            form: {
                formalContractId: '',
                offsetAmount: '',
                remark: ''
            }
        };
    },
    computed: {
        contractInfo() {
            return this.selectDetail || {};
        },
        // 申请抵扣金额固定为 合同金额-已开票金额
        offsetAmountValue() {
            return Number(this.contractInfo.contractAmount || 0) - Number(this.contractInfo.actualInvoicedAmount || 0);
        },
        // 剩余预付款是否不足以抵扣
        isInsufficient() {
            return this.remainingAmount !== null && this.offsetAmountValue > Number(this.remainingAmount);
        }
    },
    watch: {
        selectDetail: {
            handler(newVal) {
                if (newVal && newVal.id) {
                    this.form.formalContractId = newVal.id;
                    this.form.offsetAmount = this.offsetAmountValue;
                    this.getRemainingAmount(newVal.customerContactsId);
                }
            },
            immediate: true
        },
    },
    methods: {
        getContractColor,
        // 获取该用户剩余预付款
        getRemainingAmount(contactId) {
            if (contactId) {
                let params = { contactId: contactId, applyContractId: '', successContractId: '' }
                getUserAmountById(params).then(res => {
                    if (res.code === 200) {
                        this.remainingAmount = res.data
                    } else {
                        this.remainingAmount = 0
                    }
                }).catch(err => {
                    this.remainingAmount = 0
                })
            } else {
                this.remainingAmount = 0
            }
        },
        handleSubmit() {
            if (this.isInsufficient) {
                this.$messageUi.error('该用户剩余预付款不足，无法申请抵扣');
            } else {
                this.submitApply()
            }
        },
        submitApply() {
            this.loading = true;
            applyPrepaymentsDeduction({
                formalContractId: this.form.formalContractId,
                offsetAmount: this.form.offsetAmount,
                remark: this.form.remark
            }).then(res => {
                this.loading = false;
                if (res.code === 200) {
                    this.$messageUi.success('申请已提交，等待审核');
                    this.$emit('submit', 'confirm');
                }
            }).catch(err => {
                this.loading = false;
            });
        },
        cancel() {
            this.$emit('submit');
        }
    }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/detail.css";
@import "@/assets/css/contractChangeSections.scss";

.section-body {
    padding: 4px 0;
}

.offset-form {
    padding: 0 16px 16px;
    margin-top: 16px;
}

.contract-number-text {
    color: #409eff;
    font-weight: 600;
}

.insufficient-text {
    color: #f56c6c;
}

.dialog-footer {
    text-align: right;
    padding-top: 10px;
}
</style>
